export default {
  lang: {
    zh: '中文',
    en: 'English',
    lo: 'ລາວ',
    th: 'ไทย',
    select: 'Select language',
  },
  nav: {
    home: 'Home',
    services: 'Services',
    projects: 'Projects',
    news: 'News',
    contact: 'Contact',
    bookNow: 'Book Now',
    menu: 'Menu',
  },
  footer: {
    tagline: 'Professional and reliable business consulting and project services for digital transformation.',
    quickLinks: 'Quick Links',
    services: 'Services',
    projects: 'Projects',
    news: 'News',
    contact: 'Contact Us',
    contactInfo: 'Contact Info',
    email: 'Email',
    phone: 'Phone',
    workHours: 'Work Hours',
    copyright: '© {year} Wanyuntang. All rights reserved.',
  },
  brand: {
    name: 'Wanyuntang',
    subtitle: 'Business Consulting · Project Services',
  },
  common: {
    loading: 'Loading...',
    empty: 'No data',
    latest: 'Latest',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    refresh: 'Refresh',
    refreshing: 'Refreshing...',
    readMore: 'Read more →',
    backToList: '← Back to news',
    backToNews: 'Back to list',
  },
  home: {
    badge: 'Professional · Reliable · Efficient',
    title: 'Empowering Digital Transformation and Business Growth',
    desc: 'Wanyuntang provides one-stop project services including corporate websites, e-commerce platforms, and product showcases.',
    bookNow: 'Book Now',
    learnServices: 'Our Services',
    statProjects: 'Projects Delivered',
    statSatisfaction: 'Client Satisfaction',
    statSupport: 'Tech Support',
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Complete digital solutions from branding to conversion',
    viewAllServices: 'View all services →',
    projectsTitle: 'Featured Projects',
    projectsSubtitle: 'Choose your project type and book a consultation',
    newsTitle: 'Latest News',
    newsSubtitle: 'Company updates and industry insights',
    ctaTitle: 'Ready to start your project?',
    ctaDesc: 'Submit a booking form and our consultant will contact you within 24 hours.',
    ctaBtn: 'Free Consultation',
    service1Title: 'Corporate Website',
    service1Desc: 'Responsive design, SEO optimization, and brand enhancement.',
    service2Title: 'E-commerce Platform',
    service2Desc: 'Product management, orders, payments, and membership.',
    service3Title: 'Product Showcase',
    service3Desc: 'Beautiful visuals highlighting your core product value.',
  },
  services: {
    title: 'Services',
    subtitle: 'Comprehensive digital solutions to grow your business',
    bookConsult: 'Book Consultation',
    s1Title: 'Corporate Website',
    s1Desc: 'Build a professional, modern website to enhance credibility and online acquisition.',
    s1f1: 'Responsive multi-device design',
    s1f2: 'SEO optimization',
    s1f3: 'CMS content management',
    s1f4: 'Performance and security',
    s2Title: 'E-commerce Development',
    s2Desc: 'Full-featured online store with product, order, and payment integration.',
    s2f1: 'Product and inventory management',
    s2f2: 'Cart and order system',
    s2f3: 'Payment and logistics',
    s2f4: 'Membership and marketing',
    s3Title: 'Product Showcase',
    s3Desc: 'Stunning visuals to attract customers and drive conversions.',
    s3f1: 'Visual design and animation',
    s3f2: 'Product detail optimization',
    s3f3: 'Multimedia support',
    s3f4: 'Analytics and tracking',
    s4Title: 'Business Consulting',
    s4Desc: 'Professional digital transformation consulting from analysis to delivery.',
    s4f1: 'Requirements research',
    s4f2: 'Technical solution design',
    s4f3: 'Project planning',
    s4f4: 'Ongoing support',
  },
  projects: {
    title: 'Projects',
    subtitle: 'Browse project types and book your preferred solution',
    empty: 'No projects available',
    bookProject: 'Book This Project',
  },
  projectItems: {
    building: {
      name: 'Corporate Website',
      desc: 'Responsive corporate website to enhance brand image and online acquisition.',
    },
    cart: {
      name: 'E-commerce Platform',
      desc: 'Full-featured online store with product, order, and payment integration.',
    },
    sparkle: {
      name: 'Product Showcase',
      desc: 'Beautiful product showcase highlighting core value and visual experience.',
    },
  },
  news: {
    title: 'News',
    subtitle: 'Industry news and company updates',
    empty: 'No news yet. Stay tuned.',
    notFound: 'News not found or has been removed.',
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Reach us through the channels below or book via the projects page',
    emailLabel: 'Email',
    phoneLabel: 'Hotline',
    hoursLabel: 'Work Hours',
    addressLabel: 'Address',
    bookOnline: 'Book Online',
    formTitle: 'Quick Message',
    formDesc: 'Fill in the form and we will reply as soon as possible.',
    name: 'Name',
    namePh: 'Your name',
    email: 'Email',
    emailPh: "name{'@'}example.com",
    address: 'Address',
    addressPh: 'Your address (optional)',
    message: 'Message',
    messagePh: 'Describe your needs',
    submit: 'Send Message',
    fillRequired: 'Please fill in name and email',
    submitSuccess: 'Message received. We will contact you soon!',
    submitFail: 'Submission failed. Please try again.',
    defaultEmail: "contact{'@'}wanyuntang.com",
    defaultPhone: '400-888-0000',
    defaultAddress: 'China · Business Consulting Service Center',
    defaultWorkHours: 'Mon – Fri 9:00 AM – 6:00 PM',
  },
  appointment: {
    title: 'Project Booking',
    close: 'Close',
    name: 'Name',
    namePh: 'Enter your name',
    nameErr: 'Please enter at least 2 characters',
    email: 'Email',
    emailErr: 'Please enter a valid email',
    phone: 'Phone',
    phonePh: 'Optional, for contact',
    date: 'Date',
    dateErr: 'Please select a date',
    slot: 'Time Slot',
    slotPh: 'Select a time slot',
    slotErr: 'Please select a time slot',
    address: 'Address',
    addressPh: 'Optional, autocomplete supported',
    note: 'Notes',
    notePh: 'Describe your needs or questions',
    submitting: 'Submitting...',
    submit: 'Confirm Booking',
    success: 'Booking submitted. We will contact you soon!',
    fail: 'Submission failed. Please try again.',
    datePh: 'Select date',
    yearPh: 'Year',
    monthPh: 'Month',
    dayPh: 'Day',
    slot1: '09:00–10:00',
    slot2: '10:00–11:00',
    slot3: '11:00–12:00',
    slot4: '14:00–15:00',
    slot5: '15:00–16:00',
    slot6: '16:00–17:00',
  },
  admin: {
    title: 'Admin Panel',
    subtitle: 'Wanyuntang Website CMS',
    username: 'Username',
    usernamePh: 'Enter admin username',
    password: 'Password',
    passwordPh: 'Enter password',
    showPwd: 'Show',
    hidePwd: 'Hide',
    remember: 'Remember username',
    login: 'Login',
    loggingIn: 'Logging in...',
    loggedIn: 'Logged in · {user}',
    logout: 'Logout',
    loginSuccess: 'Login successful',
    loginFail: 'Login failed. Check username and password',
    fillCredentials: 'Please enter username and password',
    sessionExpired: 'Session expired. Please login again',
    loadFail: 'Failed to load data',
    appointments: 'Appointments',
    noAppointments: 'No appointments',
    colName: 'Name',
    colContact: 'Email / Phone',
    colProject: 'Project',
    colTime: 'Time',
    colStatus: 'Status',
    colAction: 'Action',
    confirmBtn: 'Confirm',
    cancelBtn: 'Cancel',
    statusPending: 'Pending',
    statusConfirmed: 'Confirmed',
    statusCancelled: 'Cancelled',
    statusUpdated: 'Status updated',
    updateFail: 'Update failed',
    messages: 'Messages',
    noMessages: 'No messages',
    colAddress: 'Address',
    colMessage: 'Message',
    colCreated: 'Submitted',
    markRead: 'Mark read',
    markUnread: 'Mark unread',
    statusUnread: 'Unread',
    statusRead: 'Read',
    contactSettings: 'Contact Address Settings',
    contactSettingsDesc: 'Displayed on the public contact page',
    saveContact: 'Save Contact Info',
    contactSaved: 'Contact info saved',
    publishNews: 'Publish News',
    editNews: 'Edit News',
    newsTitle: 'Title',
    newsSummary: 'Summary',
    newsContent: 'Content',
    newsDate: 'Publish date (e.g. 2026-07-03)',
    publish: 'Publish',
    saveEdit: 'Save Changes',
    cancelEdit: 'Cancel Edit',
    existingNews: 'Existing News',
    noNews: 'No news',
    edit: 'Edit',
    fillNews: 'Please fill in title and content',
    newsPublished: 'News published',
    newsUpdated: 'News updated',
    opFail: 'Operation failed',
  },
}
